import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  ${({ theme, show }) => css`
    z-index: ${theme.layers.alwaysOnTop};
    opacity: ${show ? '1' : '0'};
    pointer-events: ${show ? 'all' : 'none'};
  `}

  .slick-slide {
    & > div {
      display: flex;
      align-items: center;
    }
  }
`

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1100px;
  height: 95%;
  width: 100%;
  flex-direction: column;

  img {
    max-height: 100%;
    max-width: 100%;
  }
`

export const Text = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
`

export const ProjectTitle = styled.span`
  color: white;
  margin-bottom: 20px;
`

export const ProjectDescription = styled.span`
  color: white;
`

export const CloseButton = styled.button`
  ${({ theme }) => css`
    cursor: pointer;
    position: absolute;
    top: calc(5% + ${theme.spacings.xsmall});
    right: calc(5% + ${theme.spacings.medium});
    height: 25px;
    width: 25px;
    filter: invert(1);
  `}
`

